export var DocumentReadStateFilterOptions = /*#__PURE__*/function (DocumentReadStateFilterOptions) {
  DocumentReadStateFilterOptions["ALL"] = "ALL";
  DocumentReadStateFilterOptions["NONE"] = "NONE";
  DocumentReadStateFilterOptions["JUST_VIEWED"] = "JUST_VIEWED";
  return DocumentReadStateFilterOptions;
}({});
